/** Auth0 SPA SDK persists session data under keys prefixed with @@auth0spajs@@ */

export const clearAuth0SpaCache = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("@@auth0spajs@@")) {
      localStorage.removeItem(key);
    }
  });
};

export const isMissingRefreshTokenError = (err) =>
  err?.error === "missing_refresh_token" ||
  (typeof err?.message === "string" &&
    err.message.includes("Missing Refresh Token"));

/** OAuth callback query keys — must not remain in the URL after Auth0 handles the redirect. */
export const AUTH0_OAUTH_CALLBACK_PARAMS = ["code", "state"];

/**
 * Removes Auth0 callback params from a search string.
 * Keeps other params (e.g. error, error_description, invitation).
 */
export const getSearchWithoutAuth0CallbackParams = (search = "") => {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  let changed = false;

  AUTH0_OAUTH_CALLBACK_PARAMS.forEach((key) => {
    if (params.has(key)) {
      params.delete(key);
      changed = true;
    }
  });

  const next = params.toString();
  return {
    search: next ? `?${next}` : "",
    changed,
  };
};
